export interface ParticleOptions {
  x: number;
  y: number;
  count?: number;
  colors?: string[];
  minSize?: number;
  maxSize?: number;
  distance?: number;
  duration?: number;
  delay?: number;
}

export const createParticleExplosion = ({
  x,
  y,
  count = 30,
  colors = [
    'hsl(180, 70%, 60%)',
    'hsl(200, 70%, 60%)',
    'hsl(220, 70%, 60%)',
    'hsl(240, 70%, 60%)',
    'hsl(260, 70%, 60%)',
  ],
  minSize = 5,
  maxSize = 25,
  distance = 75,
  duration = 1000,
  delay = 200,
}: ParticleOptions): void => {
  // Check if browser supports Web Animations API
  if (!document.body.animate) {
    console.warn('Web Animations API not supported');
    return;
  }

  // Create particles
  for (let i = 0; i < count; i++) {
    createParticle(x, y, colors, minSize, maxSize, distance, duration, delay);
  }
};

const createParticle = (
  x: number,
  y: number,
  colors: string[],
  minSize: number,
  maxSize: number,
  distance: number,
  baseDuration: number,
  maxDelay: number
): void => {
  // Create custom particle element
  const particle = document.createElement('div');
  particle.className = 'particle-effect';

  // Calculate random size
  const size = Math.floor(Math.random() * (maxSize - minSize) + minSize);

  // Apply particle styles
  particle.style.position = 'fixed';
  particle.style.pointerEvents = 'none';
  particle.style.borderRadius = '50%';
  particle.style.width = `${size}px`;
  particle.style.height = `${size}px`;
  particle.style.background = colors[Math.floor(Math.random() * colors.length)];
  particle.style.zIndex = '99999';
  particle.style.opacity = '1';
  particle.style.boxShadow = '0 0 8px rgba(255, 215, 0, 0.6)';

  // Set initial position directly using top/left instead of transform
  particle.style.top = `${y - size / 2}px`;
  particle.style.left = `${x - size / 2}px`;

  // Append to body
  document.body.appendChild(particle);

  // Generate random destination within distance
  const destinationX = x + (Math.random() - 0.5) * 2 * distance;
  const destinationY = y + (Math.random() - 0.5) * 2 * distance;

  // Create animation using top/left instead of transform
  const animation = particle.animate(
    [
      {
        top: `${y - size / 2}px`,
        left: `${x - size / 2}px`,
        opacity: 1,
      },
      {
        top: `${destinationY - size / 2}px`,
        left: `${destinationX - size / 2}px`,
        opacity: 0,
      },
    ],
    {
      duration: baseDuration + Math.random() * 500,
      easing: 'cubic-bezier(0, .9, .57, 1)',
      delay: Math.random() * maxDelay,
    }
  );

  // Remove particle when animation completes
  animation.onfinish = () => {
    particle.remove();
  };
};
